module.exports = __webpack_public_path__ + "img/down1.6e7d1c0f.png";